import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from "reactstrap";
import Collapse from "reactstrap/lib/Collapse";
import JSAItemAnswer from "./JSAItemAnswer";

const parseJSAAnswers = (JSAAnswers, JSAItems) => {
  // First organize all items by sections
  const sections = {};
  const sectionData = {};

  JSAItems.forEach((item) => {
    const sectionId = item.jsaSectionId;
    if (!sections[sectionId]) {
      sections[sectionId] = [];
      sectionData[sectionId] = {
        id: sectionId,
        name: item.jsaSection.name,
        order: item.jsaSection.order,
      };
    }
    sections[sectionId].push({
      ...item,
      answer: false, // Default answer is false
    });
  });

  // Now mark the answers that exist in JSAAnswers
  if (JSAAnswers) {
    JSAAnswers.forEach((answer) => {
      const sectionId = answer.jsaItem.jsaSectionId;
      const itemIndex = sections[sectionId].findIndex(
        (item) => item.id === answer.jsaItem.id
      );
      if (itemIndex !== -1) {
        sections[sectionId][itemIndex].answer = answer.answer;
      }
    });
  }

  const parsedData = Object.keys(sectionData).map((sectionId) => ({
    ...sectionData[sectionId],
    items: sections[sectionId].sort((a, b) => a.order - b.order),
  }));
  return parsedData;
};

const JSAModal = ({ employeeWorkDay, onClose, JSAItems }) => {
  const [sections, setSections] = useState([]);
  const [sectionsOpen, setSectionsOpen] = useState({});

  useEffect(() => {
    const JSAAnswers = employeeWorkDay.jsaAnswers || null;
    const sections = parseJSAAnswers(JSAAnswers, JSAItems);
    setSections(sections);
  }, [employeeWorkDay.jsaAnswers, JSAItems]);

  const closeBtn = (
    <Button className="close" color="none" onClick={onClose}>
      &times;
    </Button>
  );

  return (
    <Modal isOpen={true} onClosed={onClose}>
      <ModalHeader close={closeBtn}>Job Safety Analysis</ModalHeader>
      <ModalBody>
        {sections
          .sort((x, y) => x.order - y.order)
          .map((section) => (
            <div className="mb-3" key={section.id}>
              <Button
                color="primary"
                key={section.id}
                onClick={() =>
                  setSectionsOpen({
                    ...sectionsOpen,
                    [section.id]: !sectionsOpen[section.id],
                  })
                }
                style={{ width: "100%" }}
              >
                <div className="d-flex flex-row justify-content-between m-1 align-middle">
                  <span>{section.name || `Section ${section.order}`}</span>
                  <FontAwesomeIcon
                    icon={
                      sectionsOpen[section.id] ? faChevronDown : faChevronRight
                    }
                    fixedWidth
                    className="my-1"
                  />
                </div>
              </Button>
              <Collapse isOpen={sectionsOpen[section.id]} className="p-2">
                {section.items
                  .sort((x, y) => x.order - y.order)
                  .map((item) => (
                    <JSAItemAnswer item={item} key={item.id} />
                  ))}
              </Collapse>
            </div>
          ))}
      </ModalBody>
      <ModalFooter className="justify-content-end mt-n3">
        <Button color={"primary"} onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default JSAModal;
